// Ачилт удирдлага (canvas Ord_Shipping): 3 tabs
//   Хуваарилагдсан - the pull sheet list
//   Зөрчилтэй ачаа - shortages per pull sheet (Ord_Picking)
//   Дууссан        - the same list forced to LOADED (warehouse keeper confirmed)

import { Group, Stack, Tabs } from "@mantine/core";
import { useEffect } from "react"
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useHelpContext } from "@dehub/theme"
import { PageLayout } from "../../components/layout";
import { usePermission } from "../../components/permission";
import { PickingShortage } from "../../components/picking-shortage";
import { SupplierShippingCustomerList } from "../../components/supplier-shipping-customer/list";
import { SegmentedTabs } from "../../components/ui"

const DEFAULT_TAB = "ASSIGNED"

export function SupplierShippingTab() {
  const { t } = useTranslation(["delivery", "common"])
  const breadcrumbs = useBreadcrumb(t)
  const ORD_PS_LIST = usePermission("ORD_PS_LIST")
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get("tab") || DEFAULT_TAB

  // @dehub/help: the tab is the page content variant (`when`).
  const { set: setHelpContext } = useHelpContext()
  useEffect(() => {
    setHelpContext({ when: activeTab })
  }, [activeTab, setHelpContext])

  const onTabChange = (v: string | null) => {
    const next = v ?? DEFAULT_TAB
    const params = new URLSearchParams(searchParams)
    params.set("tab", next)
    setSearchParams(params, { replace: true })
  }

  const tabs = (
    <SegmentedTabs
      value={activeTab}
      onChange={onTabChange}
      data={[
        { value: "ASSIGNED", label: t("shipping.tabs.assigned", { defaultValue: "Хуваарилагдсан" }) },
        { value: "SHORTAGE", label: t("shipping.tabs.shortage", { defaultValue: "Зөрчилтэй ачаа" }) },
        { value: "COMPLETED", label: t("shipping.tabs.completed", { defaultValue: "Дууссан" }) },
      ]}
    />
  )

  return (
    <PageLayout title={t("shipping.title")} breadcrumb={breadcrumbs}>
      {!ORD_PS_LIST.hasAccess ? ORD_PS_LIST.accessDenied() : (
        <>
          {/* Segmented tabs (one list-header concept with Борлуулалт, Дропшиппинг, Хүргэлт удирдлага) share the
              search row on the two list tabs; Зөрчилтэй ачаа has no search row, so they sit alone above it. */}
          <Tabs value={activeTab} keepMounted={false}>
            <Tabs.Panel value="ASSIGNED">
              <SupplierShippingCustomerList toolbarStart={tabs} />
            </Tabs.Panel>
            <Tabs.Panel value="SHORTAGE">
              <Stack gap="md">
                <Group>{tabs}</Group>
                <PickingShortage />
              </Stack>
            </Tabs.Panel>

            <Tabs.Panel value="COMPLETED">
              <SupplierShippingCustomerList forcedStatus="LOADED" toolbarStart={tabs} />
            </Tabs.Panel>
          </Tabs>
        </>
      )}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  {
    to: "/",
    label: t("common:breadcrumb.home"),
  },
  {
    label: t("shipping.breadcrumb"),
  },
]
